import { useEffect, useRef } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

const GUEST_REFERENCE_KEY = "guest_purchase_reference";

export default function useGuestCheckoutRedirect() {
  const hasStarted = useRef(false);

  useEffect(() => {
    const guestReference = localStorage.getItem(GUEST_REFERENCE_KEY);
    const token = Cookies.get("token");
    if (hasStarted.current || !guestReference || !token) return;
    hasStarted.current = true;

    const clearReference = () => {
      if (localStorage.getItem(GUEST_REFERENCE_KEY) === guestReference) {
        localStorage.removeItem(GUEST_REFERENCE_KEY);
      }
    };

    const openCheckout = async () => {
      try {
        const base = process.env.REACT_APP_BASE_URL_V2;
        if (!base) throw new Error("REACT_APP_BASE_URL_V2 is not set");

        const endpoint = new URL(
          "onboarding/get_stripe_payment_link_via_guest_reference",
          `${base.replace(/\/+$/, "")}/`,
        ).toString();

        const response = await axios.post(
          endpoint,
          JSON.stringify(guestReference),
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (typeof response?.data !== "string" || !response.data.trim()) {
          throw new Error("The checkout response did not contain a URL.");
        }
        const checkoutUrl = new URL(response.data);
        if (checkoutUrl.protocol !== "https:" && checkoutUrl.protocol !== "http:") {
          throw new Error("The checkout URL is invalid.");
        }

        clearReference();
        window.location.replace(response.data);
      } catch (error) {
        const status = (error as { response?: { status?: number } })?.response?.status;
        if (status === 400) {
          clearReference();
          toast.error("Your purchase reference is missing or expired. Please choose a plan again.");
        } else {
          toast.error("We could not open checkout. Refresh this page to try again.");
        }
      }
    };

    void openCheckout();
  }, []);
}
